module.exports = __webpack_public_path__ + "img/kkb_stairville_cx30.ce6931d4.png";